import React from 'react';
import whyUs from '../assets/whyUs.jpeg';

const WhyUs = () => {
  return (
    <section className="relative flex flex-col lg:flex-row md:h-[70vh]">
      {/* Left Side Content */}
      <div className="flex-1  flex flex-col justify-center px-8 lg:px-16 mx-auto lg:ml-24">
        <h3 className="text-3xl sm:text-4xl font-bold pt-20 text-primary relative inline-block mb-4">
          Why Choose
          <span className="absolute bottom-[-8px] left-0 w-12 h-1 bg-secondary"></span>
          <span className="text-secondary"> Us?</span>
        </h3>
        <p className=" text-gray-700 mb-8">
          Pixel Innovative Solutions provides advanced and innovative solutions designed to meet the needs of challenging environments. Our solutions, including Smart Helmets and PoC Radios, combine cutting-edge technology with dedicated customer support, ensuring seamless operations and enhanced business performance.
        </p>
      </div>

      {/* Right Side Image */}
      <div className="relative w-full lg:w-1/2 h-full">
        <img
          src={whyUs}
          alt="Why Us"
          className="absolute right-0 top-0 w-[90%] h-full object-cover"
        />
        {/* Overlay */}
        {/* <div className="absolute right-0 top-0 w-[90%] h-full bg-primary opacity-50" /> */}
      </div>
    </section>
  );
};

export default WhyUs;
